/**
 * Реализация не блещет продуманностью, но сейчас столбец "Стоимость со скидкой"
 * появляется только для подписки. При этом значение берётся из marketingPrice, что
 * является некорректным (marketingPrice — это цена БЕЗ скидки, price — цена С учётом скидки).
 * Со стороны приложений поля мапятся из price в marketingPrice принудительно, а
 * интерфейс сервиса пакета имеет только поле marketingPrice.
 *
 * Исправить положение поможет внедрение в интерфейс сервиса пакета поля price,
 * со стороны микросервисов нужно убрать мапинг, а с бэкенда должны приходить соответствующие поля.
 */
export const getPriceColTitle = (isPublicationSubscription: boolean): string => {
  return isPublicationSubscription ? 'Стоимость со скидкой' : 'Стоимость';
};
